<template>
    <div class="col-sm-3 mb-5 mb-xl-10" >
      <div class="card card-flush h-lg-100">
        <div class="card-header pt-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bolder text-dark">{{$t('settings.payslips')}}</span>
            <span class="text-gray-400 mt-1 fw-bold fs-6"></span>
          </h3>
        </div>
        <div class="card-body pt-5">
          <router-link :to="'rh/settings/payslips/pensions'" v-if="$can(abilities.VIEW_PENSION)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.pension')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'rh/settings/payslips/allowances'" v-if="$can(abilities.VIEW_ALLOWANCE)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.allowances')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'rh/settings/payslips/others'" v-if="$can(abilities.VIEW_OTHER)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.others')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
          <router-link :to="'rh/settings/payslips/taxes'" v-if="$can(abilities.VIEW_PAYROLL_TAX)">
            <div class="card shadow-sm p-5 mb-2">
              <div class="d-flex flex-stack" >
                <a href="#" class="text-primary opacity-75-hover fs-6 fw-bold">{{$t('settings.taxes')}}</a>
                <button type="button" class="btn btn-icon btn-sm h-auto btn-active-color-primary justify-content-end">
                  <i class="fas fa-external-link-alt" aria-hidden="true" style="color: #303D4E"></i>
                </button>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import abilities from "@/composables/abilities";
  </script>

  <style scoped>
  
  </style>